/** Separateur « ou » entre Google et le formulaire email / mot de passe. */
const AuthDivider = () => (
  <div className="relative my-6">
    <div className="absolute inset-0 flex items-center" aria-hidden="true">
      <div className="w-full border-t border-gray-200" />
    </div>
    <div className="relative flex justify-center text-sm">
      <span className="bg-white px-3 text-gray-500">ou</span>
    </div>
  </div>
);

export default AuthDivider;
